































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Customer, Invoice, emptyCustomer, Receipt, IDocument, DocumentType } from '@/services/models'

import { formatters } from '@/helpers/components-utils'

@Component
export default class DocumentSheet extends Vue {

  @Prop({
    required: true,
  })
  public doc!: IDocument

  @Prop({
    required: false,
  })
  public docHandlerTitle?: string

  public get type(): DocumentType {
    return this.doc.documentType()
  }

  public get typeLabel(): string {
    return this.type.toUpperCase().replace(/_/g, ' ')
  }

  public get typeLabelTh(): string {
    switch (this.type) {
    case 'receipt': return 'ใบเสร็จ'
    case 'invoice': return 'ใบแจ้งหนี้'
    case 'payment_voucher': return 'ใบสำคัญจ่าย'
    case 'receipt_voucher': return 'ใบสำคัญรับ'
    }
  }

  public formatters = formatters

  private get fields(): any[] {
    return [
      {key: 'index', label: '#'},
      {key: 'name', label: 'DESCRIPTION'},
      {key: 'unit', label: 'QTY', class: 'text-center'},
      {key: 'perUnit', label: 'PRICE', class: 'text-right', formatter: formatters.decimal},
      {key: 'total', label: 'TOTAL', class: 'text-right', formatter: formatters.decimal},
    ]
  }
}
